// extracted by mini-css-extract-plugin
module.exports = {"toggle":"CollapsibleComponent--toggle"};